import gql from "graphql-tag";

// @todo UPDATE THE GRAPHQL RESOLVER QUERY TO ACCEPT "WHERE"
// CONSTRAINTS IN ORDER TO BE ABLE TO FILTER THE RESULSTS ACCORDING TO CERTAIN
// CRITERIA AS LIKE AS PER STATUS, PER ID OR PER IMPLEMENTER
export const PreRequest = gql`
  query PreRequest ($id: String!) {
    preRequest(id: $id) {
      id
      folio
      estimatedBudget
      organizationDescription
      projectDescription
      projectName
      annotation
      createdAt
      status
      area
      type
      request {
        id
        project {
          id
        }
      }
    }
  }
`;
